import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { isMobileDevice } from '@src/quince-site-common/src/helpers/getDeviceTypeForPageRouter'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

import { Home } from './[...slug]/components/homepage'
import Layout from './layout'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, '/home_page1')
  // Pass data to the page via props
  // res.setHeader()
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageHome(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>
      {props.pageData ? (
        <Home pageContext={props.pageData.context?.pageDataJson} isMobile={isMobileDevice(props.deviceType)} />
      ) : (
        <SomethingWentWrong />
      )}
    </Layout>
  )
}
